import { jsx } from "react/jsx-runtime";
import { Checkbox } from "antd";
import classnames from "classnames";
import { rootClass } from "./constant.js";
function Group(props) {
    const { layout = 'horizontal', options, ...rest } = props;
    return /*#__PURE__*/ jsx(Checkbox.Group, {
        ...rest,
        options: options?.map((item)=>{
            if ('string' == typeof item || 'number' == typeof item) return {
                label: item,
                value: item,
                className: rootClass
            };
            return {
                ...item,
                className: classnames(item.className, rootClass)
            };
        }),
        className: classnames(rest.className, `${rootClass}__${layout}`)
    });
}
const checkbox_Group = Group;
export { checkbox_Group as default };
